import React from 'react';
import { handleNewTabLink } from '../../../services/Utils';

const Image = (props) => {

    if (!props.image_thumb) return '';

    return (
        <div className="image">

            <img src={props.image_card} alt={props.title} />

        </div>
    )
}

const TwentySeventeenGroupCard = (props) => {

    const handleClick = (e) => {
        handleNewTabLink(e, props.target, props.url);
    }

    return (
        <article className="card group" onClick={handleClick}>

            <div className="visual">

                <Image {...props} />

            </div>

            <div className="context">

                <a href={props.url} target={props.target}>

                    <div className="content">

                        <h5 className="title" dangerouslySetInnerHTML={{ __html: props.title }}></h5>

                        <div className="when" dangerouslySetInnerHTML={{ __html: props.when }}></div>

                        <div className="time" dangerouslySetInnerHTML={{ __html: props.time }}></div>

                        <div className="area" dangerouslySetInnerHTML={{ __html: props.area }}></div>

                    </div>

                </a>

            </div>

        </article>

    );

}

export default TwentySeventeenGroupCard;
